export const isControllableItem = (item: { item?: string }): boolean =>
  !!(item?.item && item.item !== 'assembly' && item.item !== 'wall')
